import script from "./CustomerRevenueCard.vue?vue&type=script&setup=true&lang=js"
export * from "./CustomerRevenueCard.vue?vue&type=script&setup=true&lang=js"

import "./CustomerRevenueCard.vue?vue&type=style&index=0&id=0d6fef15&scoped=true&lang=css"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.38_vue@3.5.38_webpack@5.107.2_postcss@8.5.15_/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d6fef15"]])

export default __exports__

/* vue-cli-plugin-import-components */

import BasicSpinner from "@/components/BasicSpinner.vue";
import RecordButton from "@/components/customers/record/RecordButton.vue";
import RecordCard from "@/components/customers/record/RecordCard.vue";
script.components = Object.assign({}, { BasicSpinner, RecordButton, RecordCard }, script.components);if ('__vccOpts' in script) { script.__o = script.__o || {}; script.__o.components = Object.assign({}, { BasicSpinner, RecordButton, RecordCard }, script.__o.components);}